import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FilterForm } from '@/components/filters/FilterForm'

import { setFilter } from '@/reducers/realtime/realtimeCoaching/realtimeCoaching.redux'
import { RTCDisplayGroupingOptions } from '@/utils/constants'
import { MultiSelect } from '@/components/forms/MultiSelect'
import { InfoTooltip } from '@/components/tooltips/InfoTooltip'
import { FormField } from '@/components/forms/FormField'

export const AdvancedExportsDisplayOptions = () => {
  const dispatch = useDispatch()
  const { filters } = useSelector((state) => state.realtimeCoaching)

  // Makes agents and tags options mutually exclusive
  const displayGroupingOptions = [...RTCDisplayGroupingOptions]
  const agentIndex = displayGroupingOptions.findIndex(
    (displayGrouping) => displayGrouping.value === 'agent'
  )
  const tagIndex = displayGroupingOptions.findIndex(
    (displayGrouping) => displayGrouping.value === 'tag'
  )
  displayGroupingOptions[agentIndex] = {
    ...displayGroupingOptions[agentIndex],
    isDisabled: filters.displayGroupings.some((displayGrouping) => displayGrouping.value === 'tag'),
  }
  displayGroupingOptions[tagIndex] = {
    ...displayGroupingOptions[tagIndex],
    isDisabled: filters.displayGroupings.some(
      (displayGrouping) => displayGrouping.value === 'agent'
    ),
  }

  return (
    <section>
      <h3 className="flex-align-center small-gap mt">
        Display Options
        <InfoTooltip
          content={
            <>
              <p>At a minimum, at least one display metric must be selected</p>
              <p>
                Display metrics are quantitative measurements. For example, the display metric,
                “Fired Alerts” will show the total number of alerts fired.
              </p>
              <p>
                Display groupings are attributes of your data. For example, grouping by “Agents”
                will show agents as one selected column and each row as a unique agent.
              </p>
            </>
          }
        />
      </h3>
      <FilterForm medium sticky={false}>
        <FormField required data-testid="advanced-exports-display-metrics-filter">
          <label id="metrics-dropdown">Show Me Metrics</label>
          <MultiSelect
            placeholder="Select Display Metric"
            aria-labelledby="metrics-dropdown"
            isClearable={false}
            options={[
              {
                value: 'fired_alerts',
                label: 'Fired alerts',
                accessor: 'fired_alerts',
                isDisabled: true,
              },
              { value: 'chats', label: 'Chats', accessor: 'chats', isDisabled: true },
              { value: 'listens', label: 'Listens', accessor: 'listens', isDisabled: true },
              {
                value: 'acknowledgements',
                label: 'Acknowledgements',
                accessor: 'acknowledgements',
                isDisabled: true,
              },
            ]}
            value={filters.displayMetrics}
            onChange={(value) => dispatch(setFilter({ displayMetrics: value }))}
          />
        </FormField>
        <FormField required data-testid="advanced-exports-display-grouping-filter">
          <label id="group-by-dropdown">Grouped By</label>
          <MultiSelect
            placeholder="Select Display Grouping"
            aria-labelledby="group-by-dropdown"
            options={displayGroupingOptions}
            value={filters.displayGroupings}
            onChange={(value) => dispatch(setFilter({ displayGroupings: value }))}
          />
        </FormField>
      </FilterForm>
    </section>
  )
}
